import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

import { Tabs, TabsList, TabsTrigger, TabsContent } from 'twyne-new.ui'

import DatasourceTab from './components/DatasourceTab';
import RequestTab from './components/RequestTab';
import ResponseTab from './components/ResponseTab';

const propTypes = {
  request: PropTypes.object,
  response: PropTypes.object,
  datasourceOptions: PropTypes.object,
}

export default function TestTabs({ request, response, datasourceOptions }) {
  const [containerMessage, setContainerMessage] = useState('Run the test to view the results.')

  useEffect(() => {
    if (datasourceOptions && !datasourceOptions.success) {
      setContainerMessage('Request failed, please try again.')
    }
  }, [datasourceOptions])

  return <>
    <Tabs defaultValue='request' forceMount size='sm'>
      <TabsList>
        <TabsTrigger className='pt-0' value='request'>Request</TabsTrigger>
        <TabsTrigger className='pt-0' value='response'>Response</TabsTrigger>
        <TabsTrigger className='pt-0' value='datasourceOptions'>Datasource Options</TabsTrigger>
      </TabsList>
      <div className='max-h-100 overflow-y-auto'>
        <TabsContent value='request'>
          <RequestTab data={request} containerMessage={containerMessage} />
        </TabsContent>
        <TabsContent value='response'>
          <ResponseTab data={response} containerMessage={containerMessage} />
        </TabsContent>
        <TabsContent value='datasourceOptions'>
          <DatasourceTab data={datasourceOptions} containerMessage={containerMessage} />
        </TabsContent>
      </div>
    </Tabs>
  </>
}

TestTabs.propTypes = propTypes;
TestTabs.defaultProps = {}
